module.exports = __webpack_public_path__ + "static/media/hire-chat-button.377392fd.svg";